import axios from "./axiosInstance";

const userAPI = {
  details: () => axios.post("profile"),
};

export default userAPI;
